var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"power-titulo"}},[_c('v-card',{class:_vm.tipo == 'admin'
          ? 'primary white--text titulocatalogo'
          : ' primary white--text titulomodal'},[_c('v-icon',{staticClass:"white--text",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" \n        "),_c('span',{staticClass:"subheading"},[_c('strong',[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }